import { useEffect, useState } from "react";
import { LoadingSpinner } from "../../general/loading-spinner";
import { t } from "i18next";
import { Col, Row } from "react-bootstrap";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from '@fullcalendar/daygrid';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import rrulePlugin from '@fullcalendar/rrule'
import esLocale from '@fullcalendar/core/locales/es';
import moment from 'moment';
import 'moment/locale/es';
import { Competition } from "../../../interfaces/competition";
import { getCompetitions } from "../../../services/competition";
import { Link, useNavigate } from "react-router-dom";
import competitionIcon from "../../../assets/images/competition.svg";
import { EventsBlock } from "../../blocks/events";

export function CompetitionsEvents() {
    const navigate = useNavigate();
    moment.locale('es');

    const [loaded, setLoaded] = useState(false);
    const [competitions, setCompetitions] = useState<Competition[]>([]);
    const [competitionEvents, setCompetitionEvents] = useState<any[]>([]);

    useEffect(() => {
        getCompetitions()
            .then(response => {
                setCompetitions(response.data);
                setCompetitionEvents([
                    ...competitionEvents,
                    ...response.data.map((c: Competition) => {
                        return {
                            id: c.id.toString(),
                            title: c.name,
                            classNames: ['training'], 
                            color: c.color,
                            // start: moment(c.date_start).format('YYYY-MM-DD'),
                            // startRecur: moment(c.date_start).format('YYYY-MM-DD'),
                            // end: moment(c.date_start).format('YYYY-MM-DD'),
                            // endRecur: moment(c.date_end).format('YYYY-MM-DD'),
                            rrule: {
                                freq: 'daily',
                                interval: 1,
                                dtstart: moment(c.date_start).format('YYYY-MM-DD'), // will also accept '20120201T103000'
                                until: moment(c.date_end).format('YYYY-MM-DD') // will also accept '20120201'
                            },
                            url: '/#/competitions/' + c.id + '/view'
                        }
                    })
                ]);
                setLoaded(true);
            })
            .catch(error => {
                alert(t('connection_expired'));
                localStorage.removeItem('token');
                navigate("/");
            });
    }, []);

    function eventContent(arg: any) {
        /*const handleEventClick = (event: any) => {
            event.preventDefault();
            navigate(arg.event.url);
        }*/
    
        return (<Link className={ arg.event.classNames } to={ arg.event.url } title={ arg.event.title}></Link>);
    }

    return (
        <div className="competitions-events-container">
            <h1>
                { t("Competitions and events")}
            </h1>
            { !loaded && <LoadingSpinner />}
            { loaded &&
                    <div className="container-inner">
                        <Row>
                            <Col xs={12} md={8}>
                                <div className="competitions">
                                    <h3 className="competitions-title">
                                        <img src={ competitionIcon } alt={ t("upcoming_events")} />
                                        { t("competitions") }
                                    </h3>
                                    <div className="mini-calendar-container">
                                        <FullCalendar
                                            plugins={[ rrulePlugin, dayGridPlugin, bootstrap5Plugin ]}
                                            initialView="dayGridMonth"
                                            weekends={true}
                                            firstDay={ 1 }
                                            locale={esLocale}
                                            height={ 'auto' }
                                            events={ competitionEvents }
                                            eventContent= { eventContent }
                                        />
                                    </div>
                                    <div className="events-list">
                                        { 
                                            competitions.map((c: Competition) => {
                                                return <div className="event-item">
                                                        <div className="color-mark" style={{backgroundColor: c.color}}></div>
                                                        <div className="name">
                                                            <Link to={ '/competitions/' + c.id + '/view' }  title={ c.name }>
                                                                { c.name }
                                                            </Link>
                                                        </div>
                                                        <div className="date">{ c.date_description }</div>
                                                        <div className="venue">{ c.venue_name }</div>
                                                    </div>;
                                            })
                                        }
                                    </div>
                                </div>
                            </Col>
                            <Col xs={12} md={4}>
                                <EventsBlock />
                            </Col>
                        </Row>
                    </div>
            }
        </div>
    );
}